import Vue from 'vue'

export default {
  verificar: () => Vue.http.get(`cliente/lgpd/`).then(res => res.json()),

  inserir: (body) => Vue.http.post(`cliente/lgpd/`, body).then(res => res.json())
}
